module.exports = __webpack_public_path__ + "assets/csv/teacher_analytics_enabled.csv"